module.exports = __webpack_public_path__ + "static/media/topHood.f058003b.png";